import React from 'react';
import {toast} from "react-toastify";
import {word} from "../../word.js";

function SuccessToast(props) {
    return toast.success(word.success_process, {position: "top-center", theme: "colored",});
}

export default SuccessToast;